import { AfterViewInit, Component, Inject } from '@angular/core';
import { PageHelperService } from '../helpers/page-helper.service';
import { ApplicationStatusService } from '../services/application-status.service';
import { CustomerSettings } from '../services/customer-settings-service';

@Component({
    template: '',
    standalone: false
})
export abstract class PagebaseComponent implements AfterViewInit {

  // Constuctor
  constructor(protected pageHelperService: PageHelperService, private applicationStatusService: ApplicationStatusService, customerSettings: CustomerSettings, @Inject('pageName')private pageName?: string) {
    pageHelperService.selectedCompanySubscription.subscribe(selectedCompany => {
      this.reset()
      customerSettings.getCustomerSettings(selectedCompany).subscribe(settings => {
        customerSettings.setCustomerSettings(settings);
        this.getData(this.applicationStatusService.getIsInitialised());
      })
    });
  }

  abstract reset() : void;

  abstract getData(companyChange) : void;

  // after view init.
  ngAfterViewInit() {
    if (this.applicationStatusService.getIsInitialised()) {
      this.getData(false);
    }
  }

  setIsLoading(loading: boolean) {
    this.pageHelperService.loading.next(loading)
  }

  protected checkNull(value: any) {
    if (value === undefined) {
      return null;
    }

    return value;
  }
}
